import { render } from "./InfoContact.vue?vue&type=template&id=16401d73"
import script from "./InfoContact.vue?vue&type=script&lang=js"
export * from "./InfoContact.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\paintcare\\pcsitelocator\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__